module.exports = __webpack_public_path__ + "img/9cedac4302ce93256ee77308f4593ca3.a9205fe5.jpg";